export const buildEnvironment = {
"buildId":"593967",
"buildDate":"2025-01-20T09:33:07.369Z",
"buildTimeStamp":1737365587369,
"ngVersion":"17.2.4",
"version":"8.1.6223",
"api":"+23.04.02",
"environment":"prod",
"production":true
};